import { IThemes, Themes } from '../themes/themes.model';
import { IGeoPos, GeoPos } from '../geographicalpos/geographicalpos.model';
import { IAttachments, Attachments } from '../attachments/attachments.model';

export interface IPOIState {
  current: IPoi;
  filtered: Array<IPoi>;
  ordered: Array<IPoi>;
  list: Array<IPoi>;
  page: number;
  total: number;
  size: number;
}

export interface IPoi {
  id: any;
  poi_name?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  address?: string;
  coords?: {
    lat?: number,
    lon?: number,
  };
  short_descr?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  description?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  trivia?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  attachments?: Array<IAttachments>;
  themes?: Array<IThemes>;
  geopos?: Array<IGeoPos>;
  views?: number;
  approved?: boolean;
  user_id?: number;
}

export const POI_STATE = {
  current: null,
  filtered: [],
  ordered: [],
  list: [],
  page: 0,
  total: 0,
  size: 0,
};

export class Poi implements IPoi {
  id: any;
  poi_name?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  address?: string;
  coords?: {
    lat?: number,
    lon?: number,
  };
  short_descr?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  description?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  trivia?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  attachments?: Array<IAttachments>;
  themes?: Array<IThemes>;
  geopos?: Array<IGeoPos>;
  views?: number;
  approved?: boolean;
  user_id: any;

    constructor(obj: IPoi = {} as IPoi) {
        const {
          id= null,
          poi_name= {},
          address= '',
          coords= {},
          short_descr= {},
          description= {},
          trivia= {},
          attachments= [],
          themes= [],
          geopos= [],
          views= 0,
          approved= false,
          user_id= null
        } = obj;

        this.id = id,
        this.poi_name = poi_name,
        this.address = address,
        this.coords = coords,
        this.short_descr = short_descr,
        this.description = description,
        this.trivia = trivia,
        this.attachments = attachments,
        this.themes = themes,
        this.geopos = geopos,
        this.views = views,
        this.approved = approved,
        this.user_id = user_id;
    }

    static from(obj): IPoi {
      return new Poi({
        id : obj.id,
        poi_name : {
          it: obj.name_it,
          sl: obj.name_sl,
          en: obj.name_en
        },
        address : obj.address,
        coords : {
          lat: obj.latitude,
          lon: obj.longitude
        },
        short_descr : {
          it: obj.short_descr_it,
          sl: obj.short_descr_sl,
          en: obj.short_descr_en
        },
        description : {
          it: obj.description_it,
          sl: obj.description_sl,
          en: obj.description_en
        },
        trivia : {
          it: obj.curiosita_it,
          sl: obj.curiosita_sl,
          en: obj.curiosita_en
        },
        attachments : !!obj.attachments ? Attachments.fromArray(obj.attachments) : null,
        themes : !!obj.thematicpaths ? Themes.fromArray(obj.thematicpaths) : null,
        geopos : !!obj.geographicalpos ? GeoPos.fromArray(obj.geographicalpos) : null,
        views : obj.views,
        approved : obj.approved,
        user_id : obj.user_id
      });
  }
  static fromArray(list) {
      if (!list || !(list instanceof Array)) {
          return [];
      }
      return list.map(Poi.from).filter(item => item != null);
  }

  static to(obj) {
    return {
      id : obj.id,
      name_it : obj.poi_name.it,
      name_sl : obj.poi_name.sl,
      name_en : obj.poi_name.en,
      short_descr_it : obj.short_descr.it,
      short_descr_sl : obj.short_descr.sl,
      short_descr_en : obj.short_descr.en,
      description_it : obj.description.it,
      description_sl : obj.description.sl,
      description_en : obj.description.en,
      curiosita_it : obj.trivia.it,
      curiosita_sl : obj.trivia.sl,
      curiosita_en : obj.trivia.en,
      address : obj.address,
      latitude : obj.coords.lat,
      longitude : obj.coords.lon,
      views : obj.views,
      approved : obj.approved,
      user_id : obj.user_id,
      attachments : Attachments.toArray(obj.attachments),
      thematicpaths : Themes.toArray(obj.themes),
      geographicalpos : GeoPos.toArray(obj.geopos)
    };
  }
  static toArray(list) {
      if (!list || !(list instanceof Array)) {
          return [];
      }
      return list.map(Poi.to).filter(item => item != null);
  }
}
